<template>
  <div>
    <apexchart type="radialBar" height="350" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
export default {
  name: "Charts",
  data: function() {
    return {
      chartOptions: {
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
              image: undefined
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                show: false
              }
            }
          }
        },
        colors: ["#2279B3", "#164E73", "#2EA3F2", "#30ACFF", "#2993D9"],
        labels: [],
        legend: {
          show: true,
          floating: false,
          fontSize: "16px",
          position: "left",
          offsetX: 160,
          offsetY: 10,
          width: 200,
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 0
          },
          formatter: function(seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
            // + ":  " + Math.round(opts.w.globals.series[opts.seriesIndex]) +" %";
          },
          itemMargin: {
            horizontal: 1
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false
              }
            }
          }
        ]
      }
    };
  },
  props: {
    data: {
      type: [Object],
      required: true,
      default: () => {}
    },
    labels: {
      type: Array,
      required: true,
      default: () => []
    },
    series: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  watch: {},
  created() {
    this.chartOptions.labels = this.labels;
  }
};
</script>
